// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Du-z","giftOrPromoSelector":"Eu-z","disabled":"Fu-z","subTitle":"Gu-z","selectShipAddressMessage":"Hu-z","changePayment":"Iu-z"};